import { useTheme } from 'styled-components';

import type { Translations } from '../translations';

export interface CosunoUiTheme {
  pageContentHorizontalPaddingMobile: number;
  pageContentHorizontalPaddingDesktop: number;
  pageContentTopPadding: number;
  pageContentBottomPadding: number;
  translations: Translations;
  topOffset: number;
}

export const getCosunoUiThemeValues = ({
  translations,
  topOffset = 0,
}: {
  translations: Translations;
  topOffset?: number;
}): CosunoUiTheme => ({
  pageContentHorizontalPaddingMobile: 20,
  pageContentHorizontalPaddingDesktop: 20,
  pageContentTopPadding: 20,
  pageContentBottomPadding: 100,
  translations,
  topOffset,
});

export const useCosunoUiTheme = (): CosunoUiTheme => useTheme();
